// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.friends__body {
  flex: 1;
  overflow-y: auto;
  padding: 0 var(--pad) calc(env(safe-area-inset-bottom, 0px) + 28px);
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.fcard {
  background: var(--palette-surface);
  border: 1px solid var(--palette-border);
  border-radius: 16px;
  padding: 16px;
}
.fcard--accent {
  border-color: var(--palette-primary);
  background: var(--palette-accent-soft);
}

.fcard__title {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 1.15rem;
  margin-bottom: 2px;
}
.fcard__sub {
  font-size: 0.82rem;
  color: var(--palette-text-muted);
  margin: 0 0 12px;
  line-height: 1.4;
}

.finput-row {
  display: flex;
  gap: 8px;
  align-items: center;
}
.finput {
  flex: 1;
  min-width: 0;
  font-family: var(--font-ui);
  font-size: 1rem;
  padding: 12px 14px;
  border: 1px solid var(--palette-border);
  border-radius: var(--r-btn);
  background: var(--palette-bg);
  color: var(--palette-text);
}
.finput:focus-visible {
  outline: 2px solid var(--palette-secondary);
  outline-offset: 1px;
}
.finput-row .btn {
  width: auto;
  flex: 0 0 auto;
}

.finvite {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Stacked labelled fields for the invite + accept forms. */
.finvite-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.ffield {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.ffield__label {
  font-weight: 600;
  font-size: 0.9rem;
}
.ffield__hint {
  font-size: 0.76rem;
  color: var(--palette-text-muted);
  line-height: 1.35;
}
.ffield .finput {
  width: 100%;
}
.finvite-form .btn {
  width: 100%;
}
.finvite__url {
  font-family: var(--font-ui);
  font-size: 0.8rem;
  word-break: break-all;
  background: var(--palette-surface-alt);
  border: 1px solid var(--palette-border);
  border-radius: 10px;
  padding: 10px 12px;
  color: var(--palette-text-muted);
}

.flist {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.frow {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px solid var(--palette-border);
}
.frow:first-child {
  border-top: 0;
}
.frow__main {
  flex: 1;
  min-width: 0;
}
.frow__name {
  font-weight: 600;
  font-size: 0.98rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.frow__meta {
  font-size: 0.74rem;
  color: var(--palette-text-muted);
  margin-top: 2px;
}
.frow__actions {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.frow__actions .btn {
  width: auto;
}

.fstatus {
  margin-top: 10px;
  font-size: 0.82rem;
  color: var(--palette-text-muted);
}

.btn--wide {
  width: 100%;
}

/* Row action hierarchy: the positive action (Share / Rename) leads with a
   solid, deliberate fill; the destructive action (Cancel / Remove) recedes to
   a quiet text button until the user confirms. */
.btn--soft {
  background: var(--palette-surface-alt);
  color: var(--palette-text);
  border: 1px solid var(--palette-border);
}
.btn--soft:hover {
  background: var(--palette-border);
}
.btn--quiet {
  background: transparent;
  color: var(--palette-text-muted);
  border: 1px solid transparent;
}
.btn--quiet:hover {
  color: var(--palette-text);
  background: var(--palette-surface-alt);
}

/* Destructive confirmation — solid and unmistakable, shown only after the
   quiet Cancel/Remove is tapped. */
.btn--danger {
  background: var(--palette-primary);
  color: var(--palette-on-primary);
  border: 0;
}
.btn--danger:hover {
  background: var(--palette-primary-hover);
}
.btn__icon {
  width: 18px;
  height: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/friendsScreen.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,gBAAgB;EAChB,mEAAmE;EACnE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,OAAO;EACP,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,uCAAuC;EACvC,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;EACrB,sCAAsC;EACtC,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,2CAA2C;AAC7C;AACA;EACE,aAAa;AACf;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;;iDAEiD;AACjD;EACE,sCAAsC;EACtC,0BAA0B;EAC1B,uCAAuC;AACzC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;mCACmC;AACnC;EACE,kCAAkC;EAClC,gCAAgC;EAChC,SAAS;AACX;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".friends__body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0 var(--pad) calc(env(safe-area-inset-bottom, 0px) + 28px);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.fcard {\n  background: var(--palette-surface);\n  border: 1px solid var(--palette-border);\n  border-radius: 16px;\n  padding: 16px;\n}\n.fcard--accent {\n  border-color: var(--palette-primary);\n  background: var(--palette-accent-soft);\n}\n\n.fcard__title {\n  font-family: var(--font-display);\n  font-weight: 600;\n  font-size: 1.15rem;\n  margin-bottom: 2px;\n}\n.fcard__sub {\n  font-size: 0.82rem;\n  color: var(--palette-text-muted);\n  margin: 0 0 12px;\n  line-height: 1.4;\n}\n\n.finput-row {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n.finput {\n  flex: 1;\n  min-width: 0;\n  font-family: var(--font-ui);\n  font-size: 1rem;\n  padding: 12px 14px;\n  border: 1px solid var(--palette-border);\n  border-radius: var(--r-btn);\n  background: var(--palette-bg);\n  color: var(--palette-text);\n}\n.finput:focus-visible {\n  outline: 2px solid var(--palette-secondary);\n  outline-offset: 1px;\n}\n.finput-row .btn {\n  width: auto;\n  flex: 0 0 auto;\n}\n\n.finvite {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* Stacked labelled fields for the invite + accept forms. */\n.finvite-form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.ffield {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.ffield__label {\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n.ffield__hint {\n  font-size: 0.76rem;\n  color: var(--palette-text-muted);\n  line-height: 1.35;\n}\n.ffield .finput {\n  width: 100%;\n}\n.finvite-form .btn {\n  width: 100%;\n}\n.finvite__url {\n  font-family: var(--font-ui);\n  font-size: 0.8rem;\n  word-break: break-all;\n  background: var(--palette-surface-alt);\n  border: 1px solid var(--palette-border);\n  border-radius: 10px;\n  padding: 10px 12px;\n  color: var(--palette-text-muted);\n}\n\n.flist {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n.frow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 0;\n  border-top: 1px solid var(--palette-border);\n}\n.frow:first-child {\n  border-top: 0;\n}\n.frow__main {\n  flex: 1;\n  min-width: 0;\n}\n.frow__name {\n  font-weight: 600;\n  font-size: 0.98rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.frow__meta {\n  font-size: 0.74rem;\n  color: var(--palette-text-muted);\n  margin-top: 2px;\n}\n.frow__actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.frow__actions .btn {\n  width: auto;\n}\n\n.fstatus {\n  margin-top: 10px;\n  font-size: 0.82rem;\n  color: var(--palette-text-muted);\n}\n\n.btn--wide {\n  width: 100%;\n}\n\n/* Row action hierarchy: the positive action (Share / Rename) leads with a\n   solid, deliberate fill; the destructive action (Cancel / Remove) recedes to\n   a quiet text button until the user confirms. */\n.btn--soft {\n  background: var(--palette-surface-alt);\n  color: var(--palette-text);\n  border: 1px solid var(--palette-border);\n}\n.btn--soft:hover {\n  background: var(--palette-border);\n}\n.btn--quiet {\n  background: transparent;\n  color: var(--palette-text-muted);\n  border: 1px solid transparent;\n}\n.btn--quiet:hover {\n  color: var(--palette-text);\n  background: var(--palette-surface-alt);\n}\n\n/* Destructive confirmation — solid and unmistakable, shown only after the\n   quiet Cancel/Remove is tapped. */\n.btn--danger {\n  background: var(--palette-primary);\n  color: var(--palette-on-primary);\n  border: 0;\n}\n.btn--danger:hover {\n  background: var(--palette-primary-hover);\n}\n.btn__icon {\n  width: 18px;\n  height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
